import React, { useState } from 'react'

import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { dispatchUpdateIsActivityMode } from 'store/dispatcher/Room'

import FocusMode from './FocusMode'
import Participants from './Participants'

const StaticTabs = props => {
    const { isArtefactMode } = useVideoContext()

    const [showParticipantsList, setShowParticipantsList] = useState(false)

    // FIXME: move this in better place if any, as setArtifactMode is getting called in multiple files
    React.useEffect(() => {
        dispatchUpdateIsActivityMode(isArtefactMode)
    }, [isArtefactMode])

    const toggleParticipantsList = () =>
        setShowParticipantsList(state => !state)

    return (
        <>
            <FocusMode isActive={!isArtefactMode && !showParticipantsList} />
            <Participants
                isActive={showParticipantsList}
                toggle={toggleParticipantsList}
            />
        </>
    )
}

export default StaticTabs
